import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {Chart} from 'chart.js';

declare var $: any;
import * as stringFormat from 'string-format';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss']
})
export class ResultComponent implements OnInit, AfterViewInit {

  @ViewChildren('charts') charts: QueryList<any>;
  @Input() computePropertyTax: boolean;
  @Input() search: any;


  @Input() contact = {
    propertyAddress: {
      state: '',
      street: '',
      streetCont: '',
      city: '',
      zip: '',

    },
    firstname: '',
    lastname: '',
    email: '',
    phone: ''
  };
  @Input() defaultColor = '5, 121, 162';
  @Input() result: any[] = [];
  loanCriterias: any[] = [
    {
      id: '58bf0bbd4cedfd000136f14c',
      closingCostRange: {
        '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
        closestToPar: false
      },
      selectionType: 'First',
      limit: 3,
      name: '30 Year Fixed',
      mortgageType: 'Conventional',
      loanType: 'Fixed',
      term: 30,
      varaiableLoanType: '_5_1',
      showOnlyIfSecondLoan: false,
      showOnlyIfVASelected: false,
      showWhenEmpty: true,
      ltvRange: {
        '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
        null: true
      },
      noticeConf: {
        closingCostNotices: '',
        productDescription: '',
        disclosure: ''
      },
      limitRates: true,
      showAdjAsLenderCredit: true
    },
    {
      id: '58bf0bbe4cedfd000136f1e1',
      closingCostRange: {
        '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
        closestToPar: false
      },
      selectionType: 'First',
      limit: 3,
      name: '15 Year Fixed',
      mortgageType: 'Conventional',
      loanType: 'Fixed',
      term: 15,
      varaiableLoanType: '_5_1',
      showOnlyIfSecondLoan: false,
      showOnlyIfVASelected: false,
      showWhenEmpty: true,
      ltvRange: {
        '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
        null: true
      },
      noticeConf: {
        closingCostNotices: '',
        productDescription: '',
        disclosure: ''
      },
      limitRates: true,
      showAdjAsLenderCredit: true
    },
    {
      id: '5c7ee2c14cedfd0001a7d319',
      closingCostRange: {
        '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
        closestToPar: false
      },
      selectionType: 'First',
      limit: 3,
      name: '7/1 ARM',
      mortgageType: 'Conventional',
      loanType: 'Variable',
      term: 30,
      varaiableLoanType: '_7_1',
      showOnlyIfSecondLoan: false,
      showOnlyIfVASelected: false,
      showWhenEmpty: true,
      ltvRange: {
        '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
        null: true
      },
      noticeConf: {
        closingCostNotices: '',
        productDescription: '',
        disclosure: ''
      },
      limitRates: true,
      showAdjAsLenderCredit: true
    },
    {
      id: '5d7803e54cedfd00014f6f92',
      closingCostRange: {
        '@class': 'com.cre8techlabs.entity.broker.BrokerCriteria$RangeClosingCost',
        closestToPar: false
      },
      selectionType: 'FirstLast',
      name: '5/1 Arm',
      mortgageType: 'Conventional',
      loanType: 'Variable',
      term: 30,
      varaiableLoanType: '_5_1',
      showOnlyIfSecondLoan: false,
      showOnlyIfVASelected: false,
      showWhenEmpty: true,
      ltvRange: {
        '@class': 'com.cre8techlabs.entity.range.DoubleRangeLeGt',
        null: true
      },
      noticeConf: {
        closingCostNotices: '',
        productDescription: '',
        disclosure: ''
      },
      limitRates: true,
      showAdjAsLenderCredit: true
    }
  ];
  buttons: any[] = [];


  $refData: any;

  @Input() set refData(value) {
    this.$refData = value;
    this.search = value.miniPricerPref.search;
    this.loanCriterias = this.search.loanCriterias;
    this.buttons = this.$refData.miniPricerPref.customHtmlButtons;
  }

  get refData() {
    return this.$refData;
  }

  @Output() emailNowEmitter = new EventEmitter();


  selectedLineMapByIdxInit = false;
  selectedLineMapByIdx = {};
  emptyResults = [];
  currentSection: string = 'details';
  currentIndex: number = 0

  showMoreOptionsMapByIdx = {};

  NATIONAL_PROPERTY_TAX = 1.211 / 100.0;
  emailingRateIdx: number = null;
  emailingRateIdxStart: number = null;

  constructor() {
  }

  ngOnInit() {

    // tslint:disable-next-line:forin
    for (const idx in this.result) {
      this.computeSelectedLineMapByIdxWithIdx(idx);
      this.removeMIForVALoan(idx)
    }
  }

  ngAfterViewInit(): void {
    this.emptyResults = [];
    this.charts.changes
      .subscribe(() => {

          if (!this.selectedLineMapByIdxInit) {
            this.selectedLineMapByIdxInit = true;
            this.selectedLineMapByIdx = {};
            // tslint:disable-next-line:forin
            for (const idx in this.result) {
              this.removeMIForVALoan(idx)
              this.computeSelectedLineMapByIdxWithIdx(idx);
              if (!this.result[idx]) {
                if (this.loanCriterias[idx].showWhenEmpty) {
                  this.emptyResults.push(this.loanCriterias[idx].name);
                }
              }
            }

          }
          this.charts.forEach((chart, idx) => {
            const realIdx = parseInt($(chart.nativeElement).attr('idx'), 10);
            this.render(realIdx, chart);
          });
        }
      );

  }

  computeSelectedLineMapByIdxWithIdx(idx, l = null) {
    const line = l ? l : (this.result[idx] ? this.result[idx][0] : null);

    if (!line) {
      return;
    }

    line.monthlyPayment.propertyTaxes = this.search.homeValue * this.NATIONAL_PROPERTY_TAX;
    if (this.computePropertyTax === false) {
      line.monthlyPayment.propertyTaxes = 0;
    }
    const amounts = [
      line.monthlyPayment.monthlyPI,
      line.monthlyPayment.propertyTaxes / 12,
      line.monthlyPayment.homeOwnerInsurance,
      line.monthlyPayment.mi
    ];

    const clr = this.defaultColor;
    const colors = [
      `rgba(${clr}, 1)`,
      `rgba(${clr}, 0.7)`,
      `rgba(${clr}, 0.4)`,
      `rgba(${clr}, 0.1)`,
    ];

    const labels = [
      'Principal & Interest',
      'Property Tax',
      'Home Owner Insurance',
      'Mortgage Insurance',
    ];

    // If VA loan, remove Mortgage Insurance in payment piechart
    if (line.mortgageType == 'VA') {
      const miIdx = labels.indexOf('Morgage Insurance');
      amounts.splice(miIdx);
      colors.splice(miIdx);
      labels.splice(miIdx);
    }

    // payment calculation
    const total = amounts.reduce((sum, d) => {
      return sum += d || 0;
    }, 0);

    this.selectedLineMapByIdx[idx] = {
      line,
      colors,
      labels,
      total,
      amounts
    };
    // tslint:disable-next-line:forin
    for (const i in this.selectedLineMapByIdx[idx].amounts) {
      this.selectedLineMapByIdx[idx].amounts[i] = this.selectedLineMapByIdx[idx].amounts[i] / this.selectedLineMapByIdx[idx].total * 100;
    }
  }

  removeMIForVALoan(idx) {
    const lines = this.result[idx] ? this.result[idx] : null
    if (!lines)
      return;

    for (const lineIdx in lines) {
      const line = lines[lineIdx]
      // Clear MI from monthly payment if there exists MI on VA loan
      if (line.mortgageType == 'VA' && line.monthlyPayment.mi > 0) {
        line.monthlyPayment.total -= line.monthlyPayment.mi
        line.monthlyPayment.mi = 0
      }
    }
  }

  render(idx, div) {
    const ctx = div.nativeElement.getContext('2d');
    const dataSet = {
      datasets: [{
        data: this.selectedLineMapByIdx[idx].amounts,
        backgroundColor: this.selectedLineMapByIdx[idx].colors,
        borderWidth: 0
      }],

      labels: this.selectedLineMapByIdx[idx].labels
    };

    const pieChart = new Chart(ctx, {
      type: 'doughnut',
      data: dataSet,
      options: {
        animation: {
          duration: 0
        },
        layout: {
          padding: {
            left: -75,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        tooltips: {
          enabled: false
        },
        hover: {mode: null},
        legend: {
          display: false,
          legendCallback: (chart) => {
          }
        }
      }
    });
  }

  emailRate(idx) {
    this.emailingRateIdxStart = idx;
    setTimeout(() => {
      this.emailingRateIdx = idx;
    }, 600);
  }

  selectLine(idx, l: any) {
    this.computeSelectedLineMapByIdxWithIdx(idx, l);
    this.render(idx, this.charts['_results'][idx]);
  }

  actionButton(btn: any, lineResult) {
    if (!btn.link) {
      const b = $(btn.value);
      const map = {
        loanPurpose: this.search.loanPurpose,
        propertyUse: this.search.propertyUse,
        propertyType: this.search.propertyType,
        preferredAmortization: this.search.preferredAmortization,
        zip: this.search.zip,
        state: this.search.state,
        city: this.search.city,
        homeValue: this.search.homeValue,
        amount: this.search.amount,
        fico: this.search.fico,
        lockDays: this.search.lockDays,
        secondLoanOption: this.search.secondLoanOption,
        escrowWaiver: this.search.escrowWaiver,
        secondLoanAmount: this.search.secondLoanAmount,
        unit: this.search.unit,
        rate: lineResult.adjustedRates,
        ratePeriodId: lineResult.rateGrid.id,
        rateGridId: lineResult.ratePeriod.id,
      };
      // Check href
      if (b.attr('href')) {
        const url = stringFormat(b.attr('href'), map);
        window.open(url, '_blank');
        return;
      }
      // Check onclick
      if (b.attr('onclick')) {
        // TODO
        return;
      }
      // Check ng-click
      if (b.attr('ng-click')) {
        let click = b.attr('ng-click');
        click = click.replace('openNewWindow(\'', '').replace('\')', '');
        const url = stringFormat(click, map);
        window.open(url, '_blank');
        return;
      }


    }
  }

  getLabelBtn(btn: any) {
    if (!btn.label) {
      btn.label = $(btn.value).text();
    }
    return btn.label;
  }

  backFromEmailRate() {
    this.emailingRateIdxStart = null;
    setTimeout(() => {
      this.emailingRateIdx = null;
    }, 600);
  }


  toggleSection(section: string, idx: number) {
  
      if (this.currentSection == section && this.currentIndex === idx) {
        this.currentSection = '';
      } else {
        this.currentSection = section
      }
    this.currentIndex = idx

  }

  emailNow(contact: any, loanCriteria, lines) {

    this.emailNowEmitter.emit(
      {
        ref: this.$refData.id,
        contact,
        search: this.search,
        loanCriteria,
        results: lines
      }
    );
  }
}
